export * from './report-detail.component';
export * from './report-detail.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/report/report-detail/index.ts